<template>
    <v-form v-model="valid" ref="form">
        <v-dialog v-model="dialog" width="800">
            <v-card class="no-padding">
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Refrigerate Venom</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="12">
                                You're about to indicate that you've refrigerated the following Daily Extractions ({{ sessions.length }} selected). Would you like to continue?
                                <ul>
                                    <li v-for="(barcode, index) in barcodesList" :key="index">
                                        {{barcode}}
                                    </li>
                                </ul>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-alert text type="error" v-if="errorMessage">
                                    {{errorMessage}}
                                </v-alert> 
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-row>
                                    <v-col cols="6">
                                        <v-btn color="primary darken-1" @click="refrigerate()" :disabled="!valid && !saving" :loading="saving" block>Yes</v-btn>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-btn color="warning" @click="dialog = false" block>No</v-btn>
                                    </v-col>
                                </v-row>
                                <v-spacer></v-spacer>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>

</template>

<script>
import * as venomPoolingAPI from "@/services/venomPoolingAPI";
import moment from 'moment';

export default {
    data() {
        return {
            valid: false,
            dialog: false,
            sessions: [],
            saving: false,
            errorMessage: "",
            fridgeRequest: {
                DailyExtractionSessionIDs: []
            }
        };
    },
    computed: {
        barcodesList() {
            return this.sessions.map(x => x.Barcode);
        },
        barcodes() {
            return this.sessions.map(x => x.Barcode).join(", ").replace(/,(?=[^,]*$)/, ' and');
        },
    },
    methods: {
        showDialog(sessions) {
            this.sessions = sessions;

            this.fridgeRequest.DailyExtractionSessionIDs = this.sessions.map(x => x.DailyExtractionSessionID);

            this.dialog = true;
        },
        async refrigerate() {
            this.saving = true;
            this.fridgeRequest.RefrigerateTime = moment().toDate();
            var result = await venomPoolingAPI.refrigerateVenom(this.fridgeRequest);

            if (result.sessionInFridge) {
                this.dialog = false;
                this.$emit("updated");
            } else {
                this.errorMessage = result.reason;
            }

            this.saving = false;
        }
    }
}
</script>